import React, { useState } from 'react';

const PopupEventPage = () => {
  

  return (
    <div className="bg-gray-100 h-screen flex flex-col items-center justify-center">
    <div className="text-center">
      <h1 className="text-4xl font-bold text-blue-600 mb-4">Pop Up Events</h1>
      <p className="text-gray-600 mb-6">Join us for a culinary adventure!</p>
      <p className="text-gray-600 mb-6">Stay tuned for details about our upcoming event.</p>
      <div className="flex items-center justify-center space-x-4">
        <span className="text-gray-600">Follow us on:</span>
        <a href="#" className="text-blue-600 hover:underline">Facebook</a>
        <span className="text-gray-600">|</span>
        <a href="#" className="text-blue-600 hover:underline">Instagram</a>
        <span className="text-gray-600">|</span>
        <a href="#" className="text-blue-600 hover:underline">Twitter</a>
      </div>
    </div>
  </div>
  );
};

export default PopupEventPage;
